<script setup lang="ts">
import { useOrderDetails } from "@shopware-pwa/composables-next";
import CommonLabel from "~/templates/components/CommonLabel.vue";

const { order } = useOrderDetails();

const billingAddress = computed(() => order.value?.billingAddress);
const shippingAddress = computed(() => order.value?.deliveries?.[0]?.shippingOrderAddress);
</script>

<template>
  <div
    class="grid grid-cols-2 gap-2 hyphens-auto text-sm xl:grid-cols-2"
    data-no-tracking
  >
    <div class="text-sm font-medium">
      <CommonLabel path="BWF/shop/shared/shippingAddress" />
    </div>
    <div class="xl:row-start-2">
      <div>
        {{ shippingAddress?.firstName }}
        {{ shippingAddress?.lastName }}
      </div>
      <div>
        {{ shippingAddress?.street }}
      </div>
      <div v-if="shippingAddress?.additionalAddressLine1">
        {{ shippingAddress?.additionalAddressLine1 }}
      </div>
      <div>
        {{ shippingAddress?.zipcode }}
        {{ shippingAddress?.city }}
      </div>
      <div v-if="shippingAddress?.countryState?.name">
        {{ shippingAddress?.countryState?.name }}
      </div>
      <div v-if="shippingAddress?.country">
        {{ shippingAddress?.country?.name }}
      </div>
    </div>

    <div class="text-sm font-medium">
      <CommonLabel path="BWF/shop/shared/billingAddress" />
    </div>
    <div class="xl:row-start-2">
      <div>
        {{ billingAddress?.firstName }}
        {{ billingAddress?.lastName }}
      </div>
      <div>
        {{ billingAddress?.street }}
      </div>
      <div v-if="billingAddress?.additionalAddressLine1">
        {{ billingAddress?.additionalAddressLine1 }}
      </div>
      <div>
        {{ billingAddress?.zipcode }}
        {{ billingAddress?.city }}
      </div>
      <div v-if="billingAddress?.countryState?.name">
        {{ billingAddress.countryState?.name }}
      </div>
      <div v-if="billingAddress?.country">
        {{ billingAddress?.country?.name }}
      </div>
    </div>
  </div>
</template>
